import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';
import styles from './Help.module.css.js';

const Help = React.forwardRef((_a, ref) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({}, props, { ref: ref, theme: theme, className: cn([styles['tend-ui-form-help-root'], className]) }), children));
});
Help.displayName = 'Form.Help';

export { Help };
